import { Link } from 'react-router-dom'
import { useI18n } from '../lib/i18n'

export default function NotFound() {
  const { t } = useI18n()
  return (
    <section className="section py-24 text-center">
      <h1 className="text-5xl font-bold text-white">404</h1>
      <p className="text-ink-500 mt-3">{t("This page doesn't exist.")}</p>
      <Link to="/" className="btn-primary mt-8 inline-flex">{t('Back home')}</Link>
    </section>
  )
}
